import React from 'react';
import { Grid } from '@mui/material';
import DocumentListVault from '../../document-vault/components/document-list-vault/DocumentListVault';
import { CustomersCategoryContent } from './CustomerCategoryContent';
import { ProgressOverlay } from '../../../common/progress-overlay/ProgressOverlay';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { RootState } from '../../../store';

interface DocumentsTabsProps {
  documents: any[];
  key: string;
  cardView?: boolean;
  workflow?: string | null;
  setWorkflow?: React.SetStateAction<any>;
  showWorkflowBreadcrumbs?: boolean;
  setShowWorkflowBreadcrumbs?: React.SetStateAction<any>;
}

const DocumentsTabs: React.FC<DocumentsTabsProps> = ({
  documents,
  cardView,
  workflow,
  setWorkflow,
  setShowWorkflowBreadcrumbs,
  showWorkflowBreadcrumbs,
}) => {
  // useEffect(() => {
  //   const fetchAllDocuments = async () => {
  //     // For every member, dispatch both actions and wait for both results
  //     const results = await Promise.all(
  //       company.members.map(async (member) => {
  //         console.log('Member:', member);
  //         const [docsAction, contractsAction] = await Promise.all([
  //           dispatch(fetchDocuments({ data: { user: member.id, category: 'employment' } })),
  //           dispatch(fetchDocumentContracts({ data: { user: member.id, category: 'employment' } })),
  //         ]);
  //         // Assuming the payloads contain the resulting documents/objects
  //         return [
  //           ...(Array.isArray(docsAction.payload) ? docsAction.payload : []),
  //           ...(Array.isArray(contractsAction.payload) ? contractsAction.payload : []),
  //         ];
  //       })
  //     );
  //     const filteredDocuments = results
  //       .flat()
  //       .filter((doc) => doc.employees?.includes(employee.id));
  //     setDocuments(filteredDocuments);
  //   };

  //   fetchAllDocuments();
  // }, [company.members, dispatch, documentContracts, documentUploads]);

  const documentUploadsLoading = useAppSelector((state: RootState) => state.documents.status);

  return (
    <Grid container wrap='nowrap'>
      <Grid size={{ xs: 12 }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FilterDrawer sections={filterSections} onApplyFilters={handleApplyFilters} />
        </Box> */}
        {cardView ? (
          <CustomersCategoryContent
            documents={documents}
            workflow={workflow}
            setWorkflow={setWorkflow}
            showWorkflowBreadcrumbs={showWorkflowBreadcrumbs}
            setShowWorkflowBreadcrumbs={setShowWorkflowBreadcrumbs}
          />
        ) : (
          <>
            <DocumentListVault documents={documents} />
            {documentUploadsLoading === 'loading' && (
              <ProgressOverlay className={'position-absolute'} />
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default DocumentsTabs;
